import { jsx } from 'react/jsx-runtime';
import * as React from 'react';
import '../../utils/index_orig/index.esm.js';
import '../../utils/theme/theme-provider/index.esm.js';
import styles from '../../styles/uitk-egds-form.css';
import { classNames } from '../../utils/classnames/index.esm.js';
import { EGDSContextProvider, useEGDSContext } from '../../utils/context-provider/index.esm.js';
const getClassNameList = classNames.bind(styles);
const useFormCallback = (name, transformer) => {
  const {
    data: contextData
  } = useEGDSContext();
  const {
    fieldChangeCallback
  } = contextData ?? {};
  // If (!fieldChangeCallback) {
  //   throw new Error(
  //     'fieldChangeCallback prop should be set in any UitkForm in the parent tree of a field using this hook'
  //   );
  // }
  return React.useCallback(event => {
    const transformedEvent = transformer(event);
    const {
      value = '',
      id = ''
    } = transformedEvent.currentTarget;
    fieldChangeCallback?.({
      name,
      value,
      id
    }, transformedEvent);
    return transformedEvent;
  }, [name, transformer, fieldChangeCallback]);
};
const EGDSForm = React.forwardRef((props, ref) => {
  const {
    hasRequiredFieldIndicator,
    children,
    className,
    onFieldChange,
    ...formProps
  } = props;
  const baseClass = 'uitk-form';
  const wrapperClassNames = getClassNameList(baseClass, {
    'has-required-indicator': hasRequiredFieldIndicator
  }, className);
  const contextData = {
    hasRequiredFieldIndicator,
    fieldChangeCallback: onFieldChange
  };
  return jsx(EGDSContextProvider, {
    config: {
      context: 'uitk-form-context',
      data: contextData
    },
    children: jsx("form", {
      ref: ref,
      ...formProps,
      className: wrapperClassNames,
      children: children
    })
  });
});
EGDSForm.displayName = 'EGDSForm';
export { EGDSForm, useFormCallback };